const KL_VIDEO_CAROUSEL_PANEL_SECTION_SELECTOR = '[data-kl-video-carousel]';
const KL_VIDEO_CAROUSEL_PANEL_OPEN_SELECTOR = '[data-kl-video-carousel-open]';

const klVideoCarouselOpenPanels = new WeakMap();

const klVideoCarouselPanelControllers = new WeakMap();

function getSectionPanelState(sectionElement) {
  if (!klVideoCarouselOpenPanels.has(sectionElement)) {
    klVideoCarouselOpenPanels.set(sectionElement, { openPanel: null });
  }

  return klVideoCarouselOpenPanels.get(sectionElement);
}

function getPanelForButton(openButton) {
  const panelId = openButton.getAttribute('aria-controls');

  return panelId ? document.getElementById(panelId) : null;
}

function createPanelController(panel, sectionElement, sectionPanelState) {
  const video = panel.querySelector('[data-kl-video-carousel-panel-video]');
  const closeButton = panel.querySelector('[data-kl-video-carousel-panel-close]');
  const soundButton = panel.querySelector('[data-kl-video-carousel-panel-sound]');

  if (!video || !closeButton) return null;

  let hasRetriedMuted = false;
  let openedByButton = null;

  function requestPlayback() {
    const playRequest = video.play();

    if (!playRequest || typeof playRequest.catch !== 'function') return;

    playRequest.catch((error) => {
      if (error.name === 'AbortError') return;

      if (!hasRetriedMuted && !video.muted) {
        hasRetriedMuted = true;
        video.muted = true;
        requestPlayback();
        return;
      }

      console.debug('kl-video-carousel: the panel could not play this video', {
        source: video.currentSrc,
        error,
      });
    });
  }

  function handleClickOutside(event) {
    if (panel.contains(event.target)) return;
    if (openedByButton && openedByButton.contains(event.target)) return;

    panel.close();
  }

  function handlePanelClose() {
    document.removeEventListener('click', handleClickOutside);

    video.pause();

    video.load();

    hasRetriedMuted = false;

    if (sectionPanelState.openPanel !== panel) return;

    sectionPanelState.openPanel = null;
    sectionElement.removeAttribute('data-kl-video-carousel-panel-open');
  }

  function closePanel() {
    panel.close();
    if (openedByButton) openedByButton.focus();
  }

  function handlePanelKeydown(event) {
    if (event.key !== 'Escape') return;

    closePanel();
  }

  function openPanel(openButton) {
    if (sectionPanelState.openPanel && sectionPanelState.openPanel !== panel) {
      sectionPanelState.openPanel.close();
    }

    openedByButton = openButton;
    panel.show();
    sectionPanelState.openPanel = panel;
    sectionElement.setAttribute('data-kl-video-carousel-panel-open', '');
    document.addEventListener('click', handleClickOutside);

    requestPlayback();

    closeButton.focus();
  }

  closeButton.addEventListener('click', closePanel);
  panel.addEventListener('keydown', handlePanelKeydown);
  panel.addEventListener('close', handlePanelClose);

  if (soundButton) {
    soundButton.addEventListener('click', () => {
      video.muted = !video.muted;
    });

    video.addEventListener('volumechange', () => {
      soundButton.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
    });
  }

  return { openPanel };
}

function getPanelController(panel, sectionElement, sectionPanelState) {
  if (klVideoCarouselPanelControllers.has(panel)) {
    return klVideoCarouselPanelControllers.get(panel);
  }

  const controller = createPanelController(panel, sectionElement, sectionPanelState);

  if (controller) klVideoCarouselPanelControllers.set(panel, controller);

  return controller;
}

function initVideoCarouselPanels(sectionElement) {
  const openButtons = sectionElement.querySelectorAll(KL_VIDEO_CAROUSEL_PANEL_OPEN_SELECTOR);

  if (!openButtons.length) return;

  const sectionPanelState = getSectionPanelState(sectionElement);

  openButtons.forEach((openButton) => {
    if (openButton.dataset.klVideoCarouselPanelReady === 'true') return;

    const panel = getPanelForButton(openButton);

    if (!panel) return;

    const controller = getPanelController(panel, sectionElement, sectionPanelState);

    if (!controller) return;

    openButton.dataset.klVideoCarouselPanelReady = 'true';
    openButton.addEventListener('click', () => controller.openPanel(openButton));
  });
}

function initVideoCarouselPanelsWithin(rootElement) {
  rootElement.querySelectorAll(KL_VIDEO_CAROUSEL_PANEL_SECTION_SELECTOR).forEach(initVideoCarouselPanels);
}

initVideoCarouselPanelsWithin(document);

document.addEventListener('shopify:section:load', (event) => {
  initVideoCarouselPanelsWithin(event.target);
});

document.addEventListener('kl:content:added', (event) => {
  const injectedRoot = event.detail && event.detail.root;

  if (!injectedRoot || typeof injectedRoot.closest !== 'function') return;

  const sectionElement = injectedRoot.closest(KL_VIDEO_CAROUSEL_PANEL_SECTION_SELECTOR);

  if (sectionElement) initVideoCarouselPanels(sectionElement);

  initVideoCarouselPanelsWithin(injectedRoot);
});

document.addEventListener('shopify:block:select', (event) => {
  const openButton = event.target.querySelector(KL_VIDEO_CAROUSEL_PANEL_OPEN_SELECTOR);

  if (openButton) openButton.click();
});

document.addEventListener('shopify:block:deselect', (event) => {
  const openButton = event.target.querySelector(KL_VIDEO_CAROUSEL_PANEL_OPEN_SELECTOR);

  if (!openButton) return;

  const panel = getPanelForButton(openButton);

  if (panel && panel.open) panel.close();
});
